import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { toast } from 'sonner';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const updateFunnelStatus = async () => {
      if (!user) return;

      // Get the funnel ID from the URL search params
      const searchParams = new URLSearchParams(location.search);
      const funnelId = searchParams.get('funnelId');

      if (!funnelId) {
        console.error('No funnel ID provided');
        toast.error('Could not find funnel to upgrade');
        return;
      }

      try {
        // Update the funnel's isPro status
        const funnelRef = doc(db, 'funnels', funnelId);
        await updateDoc(funnelRef, {
          isPro: true,
          upgradedAt: new Date().toISOString()
        });
        
        toast.success('Funnel upgraded successfully!');
        
        // Redirect to the funnel builder after 3 seconds
        setTimeout(() => {
          navigate(`/funnels/${funnelId}`);
        }, 3000);
      } catch (error) {
        console.error('Error upgrading funnel:', error);
        toast.error('Failed to upgrade funnel. Please contact support.');
      }
    };

    updateFunnelStatus();
  }, [navigate, location.search, user]);

  return (
    <div className="container max-w-md py-12">
      <Card className="p-6 text-center">
        <CheckCircle className="w-16 h-16 mx-auto mb-4 text-green-500" />
        <h1 className="text-2xl font-bold mb-2">Sikeres fizetésl!</h1>
        <p className="text-muted-foreground mb-6">
          Thank you for upgrading your funnel! You now have access to all premium features for this funnel.
        </p>
        <Button onClick={() => navigate('/')} className="w-full">
          Go to Dashboard
        </Button>
      </Card>
    </div>
  );
};

export default PaymentSuccess;